import type { Conversation, WorkspaceMember } from '@tradeoutlet/shared';

export interface DmCandidate { member: WorkspaceMember; dmId: string | null }

/**
 * People for the sidebar's quick DM search: matches by name, job title or email; people you already have a 1:1 DM
 * with first (most recent first), then other active staff by name. Never you, never inactive people.
 */
export function rankDmCandidates(members: WorkspaceMember[], conversations: Conversation[], me: string | null, q: string, limit = 8): DmCandidate[] {
  const term = q.trim().toLowerCase();
  if (!term) return [];
  const dmWith = new Map<string, { id: string; at: string }>();
  for (const c of conversations) {
    if (c.kind !== 'dm') continue;
    const other = c.members?.find(m => m.user_id !== me);
    if (other) dmWith.set(other.user_id, { id: c.id, at: c.last_message_at ?? '' });
  }
  const hit = (m: WorkspaceMember) => m.display_name.toLowerCase().includes(term) || (m.job_title ?? '').toLowerCase().includes(term) || (m.email ?? '').toLowerCase().includes(term);
  const pool = members.filter(m => m.user_id !== me && m.status === 'active' && hit(m));
  const starts = (m: WorkspaceMember) => (m.display_name.toLowerCase().startsWith(term) || m.display_name.toLowerCase().includes(` ${term}`) ? 0 : 1);
  const existing = pool.filter(m => dmWith.has(m.user_id)).sort((a, b) => starts(a) - starts(b) || dmWith.get(b.user_id)!.at.localeCompare(dmWith.get(a.user_id)!.at));
  const others = pool.filter(m => !dmWith.has(m.user_id)).sort((a, b) => starts(a) - starts(b) || a.display_name.localeCompare(b.display_name));
  return [...existing, ...others].slice(0, limit).map(member => ({ member, dmId: dmWith.get(member.user_id)?.id ?? null }));
}
